
import request from "../utils/request";

export function bindHostList(data) {
    return request({
        url: "/binduser/bindCmsHostList",
        data: data,
    });
}


export function editHostStatus(data) {
    return request({
        url: "/binduser/editHostStatus",
        data: data,
    });
}

export function getRechargeDetails(data) {
    return request({
        url: "/binduser/getRechargeDetails",
        data: data,
    });
}

export function addHost(data) {
    return request({
        url: "/binduser/addHost",
        data: data,
    });
}